import { render, staticRenderFns } from "./match_object.vue?vue&type=template&id=087fe8d6&scoped=true"
import script from "./match_object.vue?vue&type=script&lang=js"
export * from "./match_object.vue?vue&type=script&lang=js"
import style0 from "./match_object.vue?vue&type=style&index=0&id=087fe8d6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087fe8d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('087fe8d6')) {
      api.createRecord('087fe8d6', component.options)
    } else {
      api.reload('087fe8d6', component.options)
    }
    module.hot.accept("./match_object.vue?vue&type=template&id=087fe8d6&scoped=true", function () {
      api.rerender('087fe8d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/config_center/view/list/approval/form/components/match_object/match_object.vue"
export default component.exports